import React from 'react';
import { Link } from 'react-router-dom';
import { PrimaryButton } from './Button';

function RequestDemoButton(props) {
  return (
    <Link to="/contact-us">
      <PrimaryButton {...props}>Request a Demo</PrimaryButton>
    </Link>
  );
}

export default RequestDemoButton;
